import { createFileRoute } from "@tanstack/react-router";
import { GuestInvitationPage } from "@/components/pages/GuestInvitationPage";

export const Route = createFileRoute("/invite/$token")({
  component: GuestInvitationPage,
});
